<script setup>
import { throttledWatch, useWindowScroll } from "@vueuse/core";
import isVisible from "../../utils/isVisible";

const route = useRoute();

const { $get } = useAxios();

useHead({
  // Can be static or computed
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Новости | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Новости | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});

const loader = ref(null);
const isLoaderVisible = ref(false);
const hasNext = ref(true);
const { y: windowYScroll } = useWindowScroll();
const currentPage = ref(1);
const newsList = ref([]);
const isLoading = ref(false);

throttledWatch(
  windowYScroll,
  async () => {
    isLoaderVisible.value = isVisible(loader.value);
    if (isLoaderVisible.value && !isVisible.value) {
      await getNewPage(currentPage.value + 1);
    }
  },
  { throttle: 500 }
);

async function getPaginatedNews(page, perPage = 12) {
  return $get(
    `/api/v3/news?_limit=${perPage}&_skip=${page * perPage - perPage}`
  );
}

const isLoaded = ref(false);

onMounted(() => {
  isLoaded.value = true;
});

isLoading.value = true;
newsList.value.push(await getPaginatedNews(1));
isLoading.value = false;

async function getNewPage(page) {
  if (!hasNext.value) return;
  if (isLoading.value) return;
  currentPage.value = page;
  isLoading.value = true;
  const requestedNews = await getPaginatedNews(page);
  isLoading.value = false;
  if (requestedNews.length) {
    return newsList.value.push(requestedNews);
  }
  return (hasNext.value = false);
}
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="isLoaded">
      <r-section>
        <div class="flex flex-col space-y-7">
          <RNewsCollage
            v-for="(news, index) in newsList"
            :key="index"
            :news="news"
          />
        </div>
        <div ref="loader" v-if="hasNext">
          <RLoader />
        </div>
      </r-section>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
